/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomVersion extends models.AppSecopsSbomVersionBase {
    getFixupPrototypeFunction() { return AppSecopsSbomVersion.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomVersion>): AppSecopsSbomVersion {
        let obj = Object.assign(new AppSecopsSbomVersion(), model);
        AppSecopsSbomVersion.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomVersion>): AppSecopsSbomVersion {
        if (!model) return null;
        return AppSecopsSbomVersion.newInstance(<AppSecopsSbomVersion> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomVersion) {
        if (!obj) return;

        models.AppSecopsSbomVersion.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomVersion): boolean {
        if (models.AppSecopsSbomVersionBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsSbomVersion.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.version_number === undefined) {
            this.version_number = 0;
        }
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (this.metadata) {
            models.AppSecopsSbomVersionMetadata.fixupPrototype(this.metadata);
        }
        if (this.parser_status) {
            models.AppSecopsSbomVersionParserStatus.fixupPrototype(this.parser_status);
        }
    }

    /**
     * Unique ID of the SBOM version
     */
    sbom_version_id: string;

    /**
     * Unique ID of the previous SBOM version from which this version is created
     */
    predecessor_version_id: string;

    /**
     * Sequence number of the SBOM version
     */
    version_number: number;

    /**
     * SBOM version created date
     */
    created_at: Date;

    /**
     * Name of the user who created the SBOM version
     */
    created_by: string;

    /**
     * SBOM version updated date
     */
    updated_at: Date;

    /**
     * Name of the user who updated the SBOM version
     */
    updated_by: string;

    metadata: models.AppSecopsSbomVersionMetadata;

    parser_status: models.AppSecopsSbomVersionParserStatus;

    /**
     * List of IDs used to refer the components under the SBOM version
     */
    component_ids: Array<string>;

}
